import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { Icon, Loader } from '@hotjar/hotsauce';

import { constructFaviconUrl } from '@hotjar/webapp/lib/constructFaviconUrl';

const FAVICON_SIZE = 16;

const IconWrap = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${FAVICON_SIZE}px;
`;

const Img = styled.img<{ hidden: boolean }>`
  border-radius: 1px;
  visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
`;

const StyledSpinner = styled(Loader)`
  position: absolute;
`;

interface SiteIconProps {
  siteUrl?: string;
}

export const SiteIcon = ({ siteUrl = '', ...props }: SiteIconProps): JSX.Element => {
  const [loading, setLoading] = useState(!!siteUrl);
  const [error, setError] = useState(!siteUrl);
  const [favicon, setFavicon] = useState(() => constructFaviconUrl(siteUrl));

  useEffect(() => {
    if (siteUrl) {
      setFavicon(constructFaviconUrl(siteUrl));
    }
  }, [siteUrl, setFavicon]);

  useEffect(() => {
    setLoading(!!favicon);
    setError(!favicon);
  }, [favicon]);

  const onError = () => {
    setError(true);
    setLoading(false);
  };

  const onLoad = () => {
    setLoading(false);
  };

  return (
    <IconWrap {...props}>
      {loading ? <StyledSpinner size="m" /> : null}
      {!loading && error ? <Icon icon="site" size="m" color="text_light" /> : null}
      {siteUrl && !error ? (
        <Img
          alt="favicon"
          src={favicon}
          onLoad={onLoad}
          onError={onError}
          width={FAVICON_SIZE}
          height={FAVICON_SIZE}
          hidden={loading}
        />
      ) : null}
    </IconWrap>
  );
};
